import { Card, CardContent, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { colors, cardStyles } from "@/theme/eventsTokens.ts";

interface SectionCardProps {
  readonly title?: string;
  readonly children: ReactNode;
  readonly sx?: Record<string, unknown>;
}

export default function SectionCard({ title, children, sx }: SectionCardProps) {
  return (
    <Card elevation={0} sx={{ ...cardStyles.default, ...sx }}>
      <CardContent sx={{ p: "1.5rem", "&:last-child": { pb: "1.5rem" }, flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        {title && (
          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 600,
              color: colors.textPrimary,
              mb: 2,
              letterSpacing: "-0.01em",
            }}
          >
            {title}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  );
}
